import React, { useEffect, useState } from 'react';

const isOnline = (): boolean => {
  return typeof navigator !== 'undefined' && navigator.onLine;
};

const PUBLIC_PATHS = ['/', '/login', '/terms', '/privacy', '/gamification-support'];

export const OfflineHandler: React.FC = () => {
  const [isOffline, setIsOffline] = useState(!isOnline());
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '/';

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Don't show offline notification on public pages
  if (!isOffline || PUBLIC_PATHS.includes(pathname)) return null;

  return (
    <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50">
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded shadow-lg">
        <div className="flex">
          <div className="ml-3">
            <p className="text-sm text-yellow-700">
              <span className="font-medium">You're offline. </span>
              Some features may be limited until you reconnect to the internet
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}; 